import { Component, computed, effect, inject, Input, signal, WritableSignal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CompanyHighlightService } from '~features/company/company-highlight.service';
import { CompanylistService } from '~features/company/companylist.service';
import { ExcelService } from '~features/company/excel.service';
import { ExchangeMappingService } from '~features/company/exchangeMapping.service';
import { CompanyGridHighlightTileComponent } from '~features/company-grid/company-grid-highlight-tile/company-grid-highlight-tile.component';

@Component({
  selector: 'app-company-grid-highlight',
  imports: [CompanyGridHighlightTileComponent, RouterLink],
  templateUrl: './company-grid-highlight.component.html',
})
export class CompanyGridHighlightComponent {
  @Input() linkToAllStocks = false;
  companylistService = inject(CompanylistService);
  companyHighlightsService = inject(CompanyHighlightService);
  excelService = inject(ExcelService);
  exchangeMappingService = inject(ExchangeMappingService);

  shownTiles: WritableSignal<number> = signal(6);

  companyList = this.companyHighlightsService.getCompanyHighlights();

  filteredCompanyList = computed(() => {
    if (this.companyList()) {
      const companies = this.companyList().filter(
        (company) => company.is_public === true && ['Update', 'Initiation', 'Transaction'].includes(company.isFeatured)
      );
      // Sort the companies based on isFeatured
      // return companies.sort((a, b) => {
      //   const order = { Initiation: 0, Transaction: 1, Update: 2 };
      //   return order[a.isFeatured] - order[b.isFeatured];
      // });
      return companies;
    } else {
      return null;
    }
  });
  showAllCompanies = signal(false);

  displayedCompanies = computed(() => {
    const companies = this.filteredCompanyList() || [];
    return this.showAllCompanies() || companies.length <= 6 ? companies : companies.slice(0, 6);
  });

  remainingCompanies = computed(() => {
    const totalCompanies = (this.filteredCompanyList() || []).length;
    return Math.max(totalCompanies - 6, 0);
  });

  shouldShowToggle = computed(() => {
    return (this.filteredCompanyList() || []).length > 6;
  });

  toggleCompanyDisplay() {
    this.showAllCompanies.update((current) => !current);
  }
}
